import React, { useEffect, useState } from 'react'
import { View, Text, StyleSheet, ScrollView, TouchableOpacity, Image} from 'react-native'
import { CheckBox, Input } from 'react-native-elements'
import { responsiveFontSize, responsiveHeight, responsiveWidth } from 'react-native-responsive-dimensions'

import { LoadProduct } from '../services/firebaseServices'
import colors from '../styles/colors'
import { getDataObject, storeDataObject } from '../utils/asyncStorageBase'
import { formatPrice } from '../utils/formatPrice'
import InputSpinner from 'react-native-input-spinner'
import { MaterialCommunityIcons } from '@expo/vector-icons'
import { TextInput } from 'react-native-paper'
import MyText from '../components/MyText'


const pathRefAdditional = '/Additional'
export default function ProductDetail({route, navigation}){
    const [product, setProduct] = useState(null)
    const [category, setCategory] = useState(null)
    const [additional, setAdditional] = useState(null)

    const [checkFlavor, setCheckFlavor] = useState([])
    const [checkSize, setCheckSize] = useState({})
    const [checkAdditional, setCheckAdditional] = useState([])

    const [total, setTotal] = useState(0)
    const [obs, setObs] = useState(null)
    const [cart, setCart] = useState(null)
    useEffect(()=>{
        const c = route.params.category;
        const p = route.params.product;

        setCategory(c);
        setProduct(p);

        getDataObject('cart').then(value => {
            setCart(value)
        })

        LoadProduct(pathRefAdditional,c.key, response =>{setAdditional(response)})
    },[])


    return(
        <View style={styles.container}>
            <ScrollView>
                <Image style={styles.imgProduct} source={{uri: product?.img}}/>
                <MyText style={styles.title}>{product?.name}</MyText>
                <MyText style={styles.description}>{product?.description}</MyText>
                {product?.flavor !== undefined &&(
                    <View>
                    <MyText style={styles.tipoText}>Sabor</MyText> 
                    {product?.flavor.map((value,index) =>
                        <TouchableOpacity style={styles.containerInfo} onPress={()=>{
                            let check = [...checkFlavor];
                            const limit = parseInt(product.qtdFlavor)
                            const limp = check.filter(value => value !== undefined);
                            
                            let _total = 0;
                            if(limp.length <= limit - 1 && check[index] === undefined){
                                    check[index] = {
                                        active: !check[index],
                                        name: value.name,
                                        price: value.price
                                    };
                                    _total = total + parseFloat(formatPrice(value.price));
                            }else{
                                check.splice(index,1)
                                _total = total - parseFloat(formatPrice(value.price));
                            }
                            setTotal(_total)
                            setCheckFlavor(check)
                        }}>
                            <View style={{width: '80%'}}>
                                <MyText style={styles.nameInfo}>{value.name}</MyText>
                                <MyText style={styles.descriptionInfo}>{value.description}</MyText>
                                {value.price !== '0,00' && (<MyText style={styles.nameInfo}>+ R$ {value.price}</MyText>)}
                            </View>
                            <CheckBox
                                center
                                checked={checkFlavor[index]?.active}
                                uncheckedIcon='circle'
                                uncheckedColor={colors.gray}
                                checkedColor={colors.red} 
                                size={responsiveFontSize(1.8)}
                                checkedIcon='check-circle'
                                onPress={()=>{
                                    let check = [...checkFlavor];
                                    const limit = parseInt(product.qtdFlavor)
                                    const limp = check.filter(value => value !== undefined);
                                    
                                    let _total = 0;
                                    if(limp.length <= limit - 1 && check[index] === undefined){
                                            check[index] = {
                                                active: !check[index],
                                                name: value.name,
                                                price: value.price
                                            };
                                            _total = total + parseFloat(formatPrice(value.price));
                                    }else{
                                        check.splice(index,1)
                                        _total = total - parseFloat(formatPrice(value.price));
                                    }
                                    setTotal(_total)
                                    setCheckFlavor(check)
                                }}                                
                            />
                        </TouchableOpacity>    
                    )}
                </View>
                )}
                {product?.size !== undefined &&(
                    <View>
                        <MyText style={styles.tipoText}>Opção</MyText> 
                        {product?.size.map( (value, index) =>
                                value.active &&
                                <TouchableOpacity style={styles.containerInfo} onPress={()=>{
                                    let check = {};
                                    let _total = 0;
                                    let ultTotal = 0;
                                    if(checkSize.key !== index){
                                        if(checkSize.price !== undefined){
                                            ultTotal = parseFloat(checkSize.price);
                                        }

                                        check = {
                                            key: index,
                                            name: value.name,
                                            price: value.price
                                        };
                                        _total = total + parseFloat(formatPrice(value.price)) - ultTotal;
                                    }else{
                                        check = {}
                                        _total = total - parseFloat(formatPrice(value.price));
                                    }
                                    setTotal(_total)
                                    setCheckSize(check)
                                }}>
                                    <View style={{width: '80%'}}>
                                        <MyText style={styles.nameInfo}>{value.name}</MyText>
                                        <MyText style={styles.descriptionInfo}>R${value.price}</MyText>
                                    </View>
                                    <CheckBox
                                        center
                                        checked={checkSize.key === index}
                                        uncheckedIcon='circle'
                                        uncheckedColor={colors.gray}
                                        checkedColor={colors.red} 
                                        size={responsiveFontSize(1.8)}
                                        checkedIcon='check-circle'
                                        onPress={()=>{
                                            let check = {};
                                            let _total = 0;
                                            let ultTotal = 0;
                                            if(checkSize.key !== index){
                                                if(checkSize.price !== undefined){
                                                    ultTotal = parseFloat(checkSize.price);
                                                }
        
                                                check = {
                                                    key: index,
                                                    name: value.name,
                                                    price: value.price
                                                };
                                                _total = total + parseFloat(formatPrice(value.price)) - ultTotal;
                                            }else{
                                                check = {}
                                                _total = total - parseFloat(formatPrice(value.price));
                                            }
                                            setTotal(_total)
                                            setCheckSize(check)
                                        }}
                                    />
                                </TouchableOpacity>
                            
                        )}
                    </View>
                )}
                {additional !== null &&(
                    <View>
                        <MyText style={styles.tipoText}>Adicionais</MyText>
                        {additional.map((add,index) => {
                            let check = [...checkAdditional];
                            return(
                            <View style={styles.containerInfo}>
                                <TouchableOpacity style={{width: '70%'}} onPress={()=>{
                                    if(check[index] === undefined){
                                        let _total = 0;
                                        let qtd = 1;
                                        check[index] = {
                                            active: !check[index],
                                            name: add.name,
                                            price: add.price,
                                            qtd
                                        };
                                        _total = total + (parseFloat(formatPrice(add.price)));
                                        setTotal(_total)
                                        setCheckAdditional(check)
                                    }
                                }}>
                                    <MyText style={styles.nameInfo}>{add.name}</MyText>
                                    <MyText style={styles.descriptionInfo}>R${add.price}</MyText>
                                </TouchableOpacity> 
                                {check[index] !== undefined ? (
                                    <InputSpinner
                                        max={10}
                                        min={0}
                                        value={check[index]?.qtd}
                                        onDecrease={(num)=>{
                                            // alert(num)
                                            // let _ck = checkAdditional;
                                            check[index].qtd = num;
                                            let tt = 0;
                                            tt = total - (parseFloat(formatPrice(add.price)));
                                            setTotal(tt)
                                            if(num === 0){
                                                check.splice(index,1)
                                            }
                                            setCheckAdditional(check)
                                                                                        
                                        }}
                                        onIncrease={(num) =>{
                                            // alert(num)
                                            // let _check = checkAdditional;
                                            check[index].qtd = num;
                                            setCheckAdditional(check)
                                            let tt = 0;
                                            tt = total + (parseFloat(formatPrice(add.price)));
                                            setTotal(tt)
                                        }}
                                        skin='paper'
                                        style={{width: '30%', height: '12%', shadowOpacity: 0}}
                                        buttonStyle={{backgroundColor: 'white'}}
                                        colorPress='red'
                                        buttonFontSize={responsiveFontSize(3)}
                                        fontSize={responsiveFontSize(1.5)}
                                    />
                                ):(
                                    <CheckBox
                                        center
                                        checked={check[index]?.active}
                                        uncheckedIcon='circle'
                                        uncheckedColor={colors.gray}
                                        checkedColor={colors.red}
                                        size={responsiveFontSize(1.8)}
                                        checkedIcon='check-circle'
                                        onPress={()=>{
                                            if(check[index] === undefined){
                                                let _total = 0;
                                                let qtd = 1;
                                                check[index] = {
                                                    active: !check[index],
                                                    name: add.name,
                                                    price: add.price,
                                                    qtd
                                                };
                                                _total = total + (parseFloat(formatPrice(add.price)));
                                                setTotal(_total)
                                                setCheckAdditional(check)
                                            }
                                        }}
                                    />
                                )}
                            </View>
                            )
                })}
                    </View>
                )}
                {/* <Input
                    label='Observações'
                    labelStyle={{color: 'black', fontSize: responsiveFontSize(1.8)}}
                    inputStyle={{fontSize: responsiveFontSize(1.8)}}
                    placeholder='Ex: Retirar a cebola'
                    containerStyle={styles.obs}
                    onChangeText={ text => setObs(text)}
                /> */} 
                <TextInput
                    label={'Observação'}
                    
                    placeholder='Ex: Retirar a cebola, Blend bem passado'
                    onChangeText={ text => setObs(text)}
                    multiline
                    style={styles.obs}
                />
            </ScrollView>
            {checkSize.name !== undefined &&(
                <TouchableOpacity style={styles.btnAddPedido} onPress={()=>{
                    const limpAdditional = checkAdditional.filter(value => value !== undefined)
                    const limpFlavor = checkFlavor.filter(value => value !== undefined)
                    const flavor = limpFlavor.filter(value => value !== undefined)
                    
                    let order = {
                        product: product.name,
                        flavor,
                        size: checkSize,
                        additional: limpAdditional,
                        obs,
                        total
                    }

                    let _cart = []

                    cart !== null &&(_cart = cart);
                    
                    _cart.push(order)
                    
                    storeDataObject('cart',_cart)
                    .then(navigation.navigate('Home'));

                    
                }}>
                    <MyText style={styles.btnAddPedidoText}>Adicionar pedido</MyText>
                    <MyText style={styles.btnAddPedidoPrice}>R${total.toFixed(2)}</MyText>
                </TouchableOpacity>
            )}
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        width: responsiveFontSize(49),
        paddingTop: responsiveFontSize(5),
        alignSelf: 'center',
        backgroundColor: 'white'
    },
    title: {
        fontSize: responsiveFontSize(3),
        textAlign: 'center',
        marginVertical: responsiveFontSize(1),
        paddingHorizontal: responsiveFontSize(1)
    },
    description: {
        fontSize: responsiveFontSize(1.8),
        paddingHorizontal: responsiveFontSize(1),
        marginBottom: responsiveFontSize(1)
    },
    tipoText: {
        color: colors.black,
        fontWeight: 'bold',
        fontSize: responsiveFontSize(2),
        backgroundColor: colors.gray,
        textAlignVertical: 'center',
        alignContent: 'center',
        padding: responsiveFontSize(3)
    },
    containerInfo: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        paddingHorizontal: responsiveWidth(5),
        paddingVertical: responsiveWidth(3),
        alignItems: 'center',
        borderBottomWidth: 0.5,
        borderBottomColor: colors.gray
    },
    nameInfo: {
        fontSize: responsiveFontSize(1.8),
        marginTop: responsiveFontSize(1)
    },
    descriptionInfo: {
        fontSize: responsiveFontSize(1.5),
        marginTop: responsiveFontSize(0.5)
    },
    btnAddPedido: {
        flexDirection: 'row',
        width: responsiveFontSize(45),
        height: responsiveFontSize(6),
        backgroundColor: colors.red,
        borderRadius: responsiveFontSize(0.5),
        alignSelf: 'center',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingHorizontal: 10,
        marginTop: 10,
        marginBottom: responsiveFontSize(3)
    },
    btnAddPedidoText: {
        fontSize: responsiveFontSize(1.8),
        color: 'white'
    },
    btnAddPedidoPrice: {
        fontSize: responsiveFontSize(1.8),
        color: 'white',
        backgroundColor: colors.redBack,
        padding: responsiveWidth(0.5),
        borderRadius: 3
    },
    obs: {
        height: responsiveFontSize(8),
        maxHeight: responsiveFontSize(10),
        paddingHorizontal: responsiveFontSize(1),
        backgroundColor: 'white',
        color: 'black',
        marginBottom: responsiveFontSize(1),
        fontSize: responsiveFontSize(1.8)
    },
    imgProduct: {
        backgroundColor: colors.gray,
        width: responsiveFontSize(20),
        height: responsiveFontSize(20),
        borderRadius: responsiveFontSize(0.5),
        alignSelf: 'center'
    }
})